import Service from "../../AuthService";

const ExampleGift = {
    getExampleGift(data) {
        return Service.get(`/example_gift?start_date=${data.start_date}&end_date=${data.end_date}&customer_id=${data.customer_id}&seller_id=${data.seller_id}`);
    },
};

export default ExampleGift;
